import axios from "./axios-auth";

const state = {
    categories: []
};

const getters = {
    all(state) {
        return state.categories;
    }
};

const actions = {
    getCategories({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get("/api/categories").then(response => {
                commit("SET_CATEGORIES", response.data.categories);
                resolve(response);
            });
        });
    },
    createCategory({ commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/categories", payload).then(response => {
                // console.log(response.data);
                // commit('ADD_CATEGORY', response.data.category)
                resolve(response);
            });
        });
    },
    updateCategory({ commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .put("/api/categories/" + payload.id, payload)
                .then(response => {
                    resolve(response);
                });
        });
    },
    moveProduct({ commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .put(
                    `/api/categories/${payload.product}/move-to/${payload.category}`
                )
                .then(response => {
                    if (response.data.statusCode == 200) {
                        window.location.reload();
                    }

                    resolve(response);
                });
        });
    },
    toggleVisibility({ commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/api/categories/${payload.id}/visibility`, payload)
                .then(response => {
                    resolve(response);
                });
        });
    },
    sideCategoryToggle({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/api/categories/toggle/${payload}/priority`)
                .then(response => {
                    resolve(response);
                });
        });
    },
    removeCategory({ commit, dispatch }, payload) {
        return new Promise((resolve, reject) => {
            axios.delete("/api/categories/" + payload).then(response => {
                commit("REFRESH_CATEGORIES");
                resolve(response);
            });
        });
    }
};

const mutations = {
    SET_CATEGORIES: (state, categories) => (state.categories = categories),
    ADD_CATEGORY: (state, category) => state.categories.push(category),
    REFRESH_CATEGORIES: (state, category_id) => {
        const index = state.categories.findIndex(
            category => category.id == category_id
        );
        state.categories.splice(index, 1);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
